import { useSelector } from 'react-redux';

function useGames() {
  const gamesState = useSelector(state => state.games);

  return { ...gamesState };
}

export default useGames;
